import { render } from "./FunctionsCatalogInputVariable.vue?vue&type=template&id=b09ea962&scoped=true&ts=true"
import script from "./FunctionsCatalogInputVariable.vue?vue&type=script&lang=ts"
export * from "./FunctionsCatalogInputVariable.vue?vue&type=script&lang=ts"

import "./FunctionsCatalogInputVariable.vue?vue&type=style&index=0&id=b09ea962&lang=scss&scoped=true"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b09ea962"]])

export default __exports__